<template>
    <div>
        <b-modal :active="!!showPromptModal" id="MailRecordPromptModal" aria-modal :width="600" :can-cancel="true" :backdrop="true">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head"><p class="modal-card-title">{{ showPromptModal == 'send' ? 'E-mails sturen' : 'Test e-mail versturen' }}</p></header>

                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <p v-if="showPromptModal == 'send'">Weet je zeker dat je deze e-mail naar {{ receivers }} {{ receivers == 1 ? 'klant' : 'klanten' }} wilt versturen?</p>
                    <template v-if="showPromptModal == 'send' && emailSpreadInfo">
                        <div class="notification is-warning is-light mt-3">
                            <p>Deze e-mails worden in batches verstuurd om overbelasting te voorkomen.</p>
                            <ul class="mt-2">
                                <!-- <li>{{ emailSpreadInfo.batches }} batch{{ emailSpreadInfo.batches > 1 ? 'es' : '' }} van maximaal 50 e-mails per kwartier</li> -->
                                <li><strong>Start verzending:</strong> {{ emailSpreadInfo.startTime }}</li>
                                <li><strong>Einde verzending:</strong> {{ emailSpreadInfo.endTime }}</li>
                                <li><strong>Totale verzendtijd:</strong> {{ emailSpreadInfo.spreadTimeInMinutes }} minuten</li>
                            </ul>
                        </div>
                    </template>
                    <p v-if="showPromptModal == 'test'">Het is mogelijk om een testmail te versturen naar een specifiek email adres. Dit is handig om te controleren of de content naar wens is.</p>
                    <p v-if="showPromptModal == 'test' && !record.sendDirect">De testmail wordt direct verstuurd.</p>

                    <b-field label="Naar wie wil je deze testmail sturen?"
                        :message="getError(errors, 'email')"
                        :type="getType(errors, 'email', '')"
                        v-if="showPromptModal == 'test'"
                    >
                        <b-input v-model="record.email"></b-input>
                    </b-field>
                </section>

                <footer class="modal-card-foot text-right">
                    <b-button class="button" type="button" @click="showPromptModal = null" v-show="!loading">Annuleren</b-button>

                    <b-button class="button is-info"
                        @click="showPromptModal = 'test'"
                        v-if="showPromptModal == 'send'">
                        Eerst testen
                    </b-button>
                    <b-button class="button is-success" @click="saveAndSend" :loading="loading" icon-right="paper-plane" v-if="showPromptModal == 'send'">
                        {{ record.sendDirect ? 'Ja, nu mailen' : 'Ja, nu inplannen' }}
                    </b-button>
                    <b-button class="button is-success"
                        @click="sendTestMail"
                        :loading="loading"
                        :disabled="isPreviewBlocked"
                        icon-right="paper-plane"
                        v-if="showPromptModal == 'test'">
                        {{ isPreviewBlocked ? `Wacht ${previewCountdown}s` : 'Verstuur testmail' }}
                    </b-button>
                </footer>
            </div>
        </b-modal>

        <!-- FindCustomer is rendered but hidden, we trigger its internal modal -->
        <FindCustomer ref="findCustomer" :show-all-customers="true" :can-add-customer="true" :only-modal="true" @linkCustomer="onCustomerSelect" />

        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-button tag="router-link" :to="{ name: 'MailOverview' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column small-9">
                <h1>Bericht {{ mode === 'new' ? 'sturen' : 'bekijken' }}</h1>
            </div>
        </div>

        <div v-if="mode === 'view'">
            <div class="row">
                <div class="column">
                    <form class="form">
                        <b-tabs size="is-medium" class="block" v-model="tabIndex">
                            <b-tab-item label="Algemeen">
                                <b-field label="Email onderwerp" style="margin-bottom:0">
                                    <b-input v-model="record.subject" placeholder="Titel" maxlength="255" disabled></b-input>
                                </b-field>

                                <div class="row">
                                    <div class="column medium-9">
                                        <b-field label="Naar wie wil je deze mail sturen?">
                                            <b-select placeholder="Selecteer een mail type" v-model="record.type" :disabled="mode == 'view'" expanded>
                                                <option value="test">Test - alleen naar mij versturen</option>
                                                <option value="specific_customer">Klant zoeken</option>
                                                <option value="all_organisation_users">Alle gebruikers in mijn organisatie</option>
                                                <option value="all_customers">Alle klanten</option>
                                                <option value="all_customers_contracts">Alle klanten met actieve contracten</option>
                                                <option value="invoiced_previous_month">Alle klanten welk vorige maand gefactureerd zijn</option>
                                                <option value="invoiced_this_month">Alle klanten welk deze maand gefactureerd zijn of worden</option>
                                                <optgroup label="Prijswijzigingen" v-if="priceChanges.length">
                                                    <option v-for="pc in priceChanges" :key="pc.id" :value="'pricechange_' + pc.id">
                                                        Prijswijziging van {{ moment(pc.date_from).format('DD-MM-YYYY') }}
                                                    </option>
                                                </optgroup>
                                            </b-select>
                                        </b-field>
                                    </div>
                                    <div class="column medium-3">
                                        <b-field label="Ontvangers">
                                            <b-input placeholder="Disabled" disabled :value="receivers"></b-input>
                                        </b-field>
                                    </div>
                                </div>

                                <slide-up-down :duration="500" :active="record.type === 'specific_customer'">
                                    <div class="row">
                                        <div class="column">
                                            <b-field label="Klant">
                                                <div v-if="_.has(record, 'customer')">
                                                    {{ record.customer.firstname }} {{ record.customer.lastname }} ({{ record.customer.email }})
                                                </div>
                                            </b-field>
                                        </div>
                                    </div>
                                </slide-up-down>

                                <div class="row" v-if="record.type !== 'test'">
                                    <div class="column medium-12">
                                        <b-field>
                                            <b-switch
                                                v-model="record.sendDirect"
                                                :true-value="true"
                                                :false-value="false"
                                                disabled
                                            >
                                                Direct versturen
                                            </b-switch>
                                        </b-field>
                                    </div>
                                    <template v-if="!record.sendDirect">
                                        <div class="column medium-6">
                                            <b-field label="Verzend datum">
                                                <b-datepicker
                                                    v-model="record.send_date"
                                                    disabled
                                                    placeholder="Klik om datum te selecteren"
                                                />
                                            </b-field>
                                        </div>
                                        <div class="column medium-6">
                                            <b-field label="Verzend tijd">
                                                <b-timepicker
                                                    v-model="record.send_time"
                                                    placeholder="Klik om tijd te selecteren"
                                                    disabled
                                                />
                                            </b-field>
                                        </div>
                                    </template>
                                </div>

                                <hr>

                                <b-field label="Content"></b-field>

                                <div style="border:1px solid #dbdbdb;padding:10px;border-radius:4px;">
                                    <div v-html="emailIntro" style="font-size:13px;padding:0 15px 0px 15px;"></div>
                                    <QuillEditor
                                        :theContent="record.content"
                                        :readOnly="true"
                                        :toolbar="[]"
                                        v-if="mode == 'new'"
                                    />
                                    <div v-html="record.content" style="font-size:13px;padding:0 15px 0px 15px;"v-else />
                                    <br>
                                    <div v-html="emailFooter" style="font-size:13px;padding:0 15px 0px 15px;"></div>
                                </div>
                            </b-tab-item>
                            <b-tab-item :label="receiversList.length > 0 ? 'Ontvangers ('+total+')' : 'Ontvanger'" :visible="mode == 'view'">
                                <b-table
                                    :data="receiversList"
                                    :loading="receiversLoading"
                                    paginated
                                    backend-pagination
                                    :total="total"
                                    :per-page="perPage"
                                    @page-change="onPageChange"
                                    :current-page.sync="page"
                                    per-page="25"
                                    striped
                                    hoverable
                                    :pagination-simple="false"
                                    pagination-position="bottom"
                                    default-sort-direction="asc"
                                    sort-icon="arrow-up"
                                    sort-icon-size="is-small"
                                >
                                    <b-table-column field="firstname" label="Voornaam" sortable v-slot="props">
                                        {{ props.row.firstname }}
                                    </b-table-column>
                                    <b-table-column field="lastname" label="Achternaam" sortable v-slot="props">
                                        {{ props.row.lastname }}
                                    </b-table-column>
                                    <b-table-column field="email" label="E-mail" sortable v-slot="props">
                                        {{ props.row.email }}
                                    </b-table-column>

                                    <b-table-column label="" numeric v-slot="props">
                                        <b-button
                                            v-if="props.row.customer_id"
                                            tag="router-link"
                                            :to="{ name: 'CustomersRecord', params: { id: props.row.customer_id } }"
                                            type="is-dark"
                                            size="is-small"
                                        >
                                            Bekijken
                                        </b-button>
                                    </b-table-column>

                                    <template #empty>
                                        <div class="has-text-centered">Geen ontvangers gevonden</div>
                                    </template>
                                </b-table>
                            </b-tab-item>
                        </b-tabs>
                    </form>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="column">
                    <form class="form verticalpadding">
                        <b-field label="Email onderwerp" style="margin-bottom:0"
                            :message="getError(errors, 'subject')"
                            :type="getType(errors, 'subject', '')"
                        >
                            <b-input v-model="record.subject" placeholder="Titel" maxlength="255"></b-input>
                        </b-field>

                        <div class="row">
                            <div class="column medium-9">
                                <b-field label="Naar wie wil je deze mail sturen?">
                                    <!-- When adding types here, also update in MailOverview! -->
                                    <b-select placeholder="Selecteer een mail type" v-model="record.type" :disabled="mode == 'edit' || !!$route.query.pricechange" expanded>
                                        <option value="test">Test - alleen naar mij versturen</option>
                                        <option value="specific_customer">Klant zoeken</option>
                                        <option value="all_organisation_users">Alle gebruikers in mijn organisatie</option>
                                        <option value="all_customers">Alle klanten</option>
                                        <option value="all_customers_contracts">Alle klanten met actieve contracten</option>
                                        <option value="invoiced_previous_month">Alle klanten welk vorige maand gefactureerd zijn</option>
                                        <option value="invoiced_this_month">Alle klanten welk deze maand gefactureerd zijn of worden</option>
                                        <optgroup label="Prijswijzigingen" v-if="priceChanges.length">
                                            <option v-for="pc in priceChanges" :key="pc.id" :value="'pricechange_' + pc.id">
                                                Prijswijziging van {{ moment(pc.date_from).format('DD-MM-YYYY') }}
                                            </option>
                                        </optgroup>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column medium-3">
                                <b-field label="Ontvangers">
                                    <b-input placeholder="Disabled" disabled :value="receivers"></b-input>
                                </b-field>
                            </div>
                        </div>

                        <slide-up-down :duration="500" :active="record.type === 'specific_customer'">
                            <div class="row">
                                <div class="column">
                                    <b-field label="Klant"
                                        :message="getError(errors, 'customer')"
                                        :type="getType(errors, 'customer', '')"
                                    >
                                        <div v-if="mode == 'edit' && _.has(record, 'customer')">
                                            {{ record.customer.firstname }} {{ record.customer.lastname }} ({{ record.customer.email }})
                                        </div>
                                        <div v-else-if="selectedCustomer" class="is-flex is-align-items-center">
                                            <span>{{ selectedCustomer.firstname }} {{ selectedCustomer.lastname }} ({{ selectedCustomer.email }})</span>
                                            <b-button class="ml-2" type="is-danger" outlined size="is-small" @click="selectedCustomer = null; record.customer = null; receivers = 0">
                                                Deselecteren
                                            </b-button>
                                        </div>
                                        <b-button v-else @click="findCustomer">
                                            Klant zoeken
                                        </b-button>
                                    </b-field>
                                </div>
                            </div>
                        </slide-up-down>

                        <div class="row" v-if="record.type !== 'test'">
                            <div class="column medium-12">
                                <b-field>
                                    <b-switch
                                        v-model="record.sendDirect"
                                        :true-value="true"
                                        :false-value="false"
                                        :disabled="mode == 'edit'"
                                        @input="value => !value && setDefaultSchedule()"
                                    >
                                        Direct versturen
                                    </b-switch>
                                </b-field>
                            </div>
                            <template v-if="!record.sendDirect">
                                <div class="column medium-6">
                                    <b-field label="Verzend datum"
                                        :message="getError(errors, 'scheduled_date')"
                                        :type="getType(errors, 'scheduled_date', '')"
                                    >
                                        <b-datepicker
                                            v-model="record.send_date"
                                            :min-date="new Date()"
                                            :max-date="maxScheduleDate"
                                            :disabled="mode == 'edit'"
                                            :nearby-selectable-month-days="true"
                                            placeholder="Klik om datum te selecteren"
                                        />
                                    </b-field>
                                </div>
                                <div class="column medium-6">
                                    <b-field label="Verzend tijd"
                                        :message="getError(errors, 'scheduled_time')"
                                        :type="getType(errors, 'scheduled_time', '')"
                                    >
                                        <b-timepicker
                                            v-model="record.send_time"
                                            placeholder="Klik om tijd te selecteren"
                                            :increment-minutes="15"
                                            :disabled="mode == 'edit'"
                                            :minutes-in-hour="[0, 15, 30, 45]"
                                            :hours-range="[9, 17]"
                                        />
                                    </b-field>
                                </div>
                            </template>
                        </div>

                        <hr>

                        <b-field label="Content"
                            :message="getError(errors, 'content')"
                            :type="getType(errors, 'content', '')"
                        ></b-field>

                        <div style="border:1px solid #dbdbdb;padding:10px;border-radius:4px;">
                            <div v-html="emailIntro" style="font-size:13px;padding:0 15px 0px 15px;"></div>
                            <QuillEditor
                                :theContent="record.content"
                                @contentChanged="contentChanged"
                                :toolbar="[
                                    ['bold', 'italic', 'underline', 'strike'],
                                    ['blockquote'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                    [{ 'color': [] }],
                                ]"
                            />

                            <br>

                            <!-- Email Footer! -->
                            <div v-html="emailFooter" style="font-size:13px;padding:0 15px 0px 15px;"></div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row" v-show="!hideSaving">
                <div class="column text-right">
                    <div class="formfooter">
                        <b-button type="is-primary" :loading="loading" @click="prompt('test')" :disabled="!receivers">Verstuur testmail</b-button>
                        <b-button type="is-success" :loading="loading" @click="prompt('send')" :disabled="!receivers || record.type == 'test'">
                            Versturen
                            <font-awesome-icon icon="paper-plane" v-if="receivers == 1"/>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuillEditor from '@/vue/QuillEditor'
import FindCustomer from '@/vue/FindCustomer'
import toastMixin from '@/mixins/toastMixins'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'

export default {
    name: 'MailRecord',

    components: {
        QuillEditor,
        FindCustomer
    },

    mixins: [toastMixin, formvalidationMixin],

    data() {
        return {
            tabIndex: 0,
            mode: 'new',
            loading: false,
            receivers: 0,
            record: {
                type: null,
                sendDirect: true,
                send_date: null,
                send_time: new Date(new Date().setHours(9, 0, 0))
            },
            errors: {},
            emailFooter: '',
            emailIntro: '',
            showPromptModal: null,
            lastPreviewSentTime: null,
            countdownTimer: null,
            mailDelay: 60,
            currentCountdown: 0,
            showFindCustomerModal: false,
            selectedCustomer: null,
            receiversList: [],
            receiversLoading: false,
            page: 1,
            perPage: 25,
            total: 0,
            priceChanges: []
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        hideSaving() {
            let hideSaving = false

            if(_.has(this.user.organisation_settings, 'strictmassamail') && this.user.organisation_settings.strictmassamail == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideSaving = true
            }
            if(this.mode == 'view'){
                hideSaving = true
            }

            return hideSaving
        },

        isPreviewBlocked() {
            return this.currentCountdown > 0
        },

        previewCountdown() {
            return this.currentCountdown
        },

        maxScheduleDate() {
            const date = new Date()
            date.setDate(date.getDate() + 7)
            return date
        },

        emailSpreadInfo() {
            if (this.receivers <= 50) return null

            const batches = Math.ceil(this.receivers / 50)
            const now = new Date()
            let startTime

            // Always calculate next quarter hour
            const minutes = now.getMinutes()
            const nextQuarter = Math.ceil(minutes / 15) * 15
            let hours = now.getHours()
            let adjustedMinutes = nextQuarter

            // Handle hour rollover
            if (nextQuarter >= 60) {
                hours += 1
                adjustedMinutes = 0
            }

            if (!this.record.sendDirect && this.record.send_date && this.record.send_time) {
                const selectedTime = new Date(this.record.send_date)
                selectedTime.setHours(
                    this.record.send_time.getHours(),
                    this.record.send_time.getMinutes(),
                    0
                )

                // Use selected time only if it's in the future
                if (selectedTime > now) {
                    startTime = selectedTime
                } else {
                    startTime = new Date(now)
                    startTime.setHours(hours, adjustedMinutes, 0, 0)
                }
            } else {
                // Direct sending - use next quarter hour
                startTime = new Date(now)
                startTime.setHours(hours, adjustedMinutes, 0, 0)
            }

            const spreadTimeInMinutes = (batches - 1) * 15
            const endTime = new Date(startTime.getTime() + spreadTimeInMinutes * 60 * 1000)

            return {
                batches,
                startTime: startTime.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }),
                endTime: endTime.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }),
                spreadTimeInMinutes
            }
        }
    },

    created() {
        if(this.$route.params.id != 'nieuw') {
            this.mode = 'view'
            this.loadReceivers(this.page)
            this.fetchAllPriceChanges().then(() => {
                this.fetchRecord()
            });

            if(this.$route.query.receivers){
                this.tabIndex = 1
            }
        } else {
            this.fetchAllPriceChanges()
            if(this.$route.query.pricechange) {
                const priceChangeId = this.$route.query.pricechange
                this.$set(this.record, 'type', `pricechange_${priceChangeId}`)
                this.fetchPriceChangeCommunication(priceChangeId)
            } else {
                this.$set(this.record, 'type', 'test')
            }
            this.$set(this.record, 'organisation', this.user.organisation)
            this.$set(this.record, 'email', this.user.email)
        }
    },

    methods: {
        fetchRecord() {
            axios.get('/api/mail/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.record = response.data

                if (this.record.customer) {
                    this.selectedCustomer = this.record.customer
                }

                // Convert send_date string to Date object
                if (this.record.send_date) {
                    this.record.send_date = new Date(this.record.send_date)
                }

                // Create send_time Date object from send_date hours/minutes
                if (this.record.send_date) {
                    const sendDate = new Date(this.record.send_date)
                    this.record.send_time = new Date()
                    this.record.send_time.setHours(sendDate.getHours())
                    this.record.send_time.setMinutes(sendDate.getMinutes())
                }

                this.receivers = response.data.receivers
            }).catch((error) => {
                this.$buefy.toast.open({message: 'Error: Mail kan niet geopend worden!', type: 'is-danger'})
                this.$router.push({name: 'MailsOverview'})
            }).then(() => {
                this.loading = false
            })
        },

        loadReceivers(page) {
            this.receiversLoading = true
            axios.get(`/api/mail/${this.$route.params.id}/receivers?page=${page}&per_page=${this.perPage}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(response => {
                this.receiversList = response.data.data
                this.total = response.data.total
                this.page = response.data.current_page
            }).catch(error => {
                this.$buefy.toast.open({message: 'Error: Kon ontvangers niet laden!', type: 'is-danger'})
            }).then(() => {
                this.receiversLoading = false
            })
        },

        onPageChange(page) {
            this.loadReceivers(page)
        },

        prompt(type) {
            if (this.receivers === 1 && type === 'send') {
                this.saveAndSend()
                return
            }

            this.showPromptModal = type
        },

        fetchIntroFooterText(orgId) {
            this.loading = true

            const params = {}
            if(this.record?.customer){
                params.customer = this.record.customer.id
            }

            axios.get('/api/mail/intro-footer-text/'+orgId, {
                params,
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$set(this, 'emailIntro', response.data.intro)
                this.$set(this, 'emailFooter', response.data.footer)
            }).catch((error) => {
                console.error('[❌] Error while fetching intro/footer text', error)
            }).then(() => {
                this.loading = false
            })
        },

        fetchReceiversCount(type) {
            if(this.mode == 'view' || type === 'specific_customer') return false
            this.receivers = 0

            if(type == 'test'){
                this.receivers = 1
                return;
            }

            this.loading = true

            axios.get(`/api/mail/receiverscount/${this.user.role == 'pit' ? this.record.organisation : this.user.organisation}/${type}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.receivers = response.data
                this.record.type = type // set again
            }).catch((error) => {
                console.error('[❌] Error while fetching footertext', error)
                this.receivers = 0;
            }).then(() => {
                this.loading = false
            })
        },

        saveAndSend() {
            this.errors = {}
            this.loading = true

            // Add scheduled date and time to the record if not sending directly
            if (!this.record.sendDirect && this.record.send_date && this.record.send_time) {
                const scheduledDateTime = new Date(this.record.send_date)
                scheduledDateTime.setHours(
                    this.record.send_time.getHours(),
                    this.record.send_time.getMinutes(),
                    0
                )
                this.record.send_date = scheduledDateTime.toISOString()
            } else {
                this.record.send_date = null
            }

            axios.post('/api/mail', this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                if (this.record.type == 'specific_customer') {
                    this.showMessage('Mails succesvol verzonden!')
                } else {
                    this.showMessage('Mails succesvol toegevoegd aan mail verzendlijst!')
                }

                this.$router.push({name: 'MailOverview'})
            }).catch((error) => {
                console.error('[❌] Error while saving mass mail:', error)
                this.showPromptModal = false

                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                } else {
                    this.errors = {...error.response.data.errors}
                    this.showError('Opslaan mislukt - Onvoldoende of onjuiste gegevens.')
                }

                this.loading = false
            }).then(() => {
                this.loading = false
            })
        },

        startCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
            }

            this.currentCountdown = this.mailDelay

            this.countdownTimer = setInterval(() => {
                if (this.currentCountdown <= 0) {
                    clearInterval(this.countdownTimer)
                    this.countdownTimer = null
                    this.lastPreviewSentTime = null
                    return
                }
                this.currentCountdown--
            }, 1000)
        },

        sendTestMail() {
            this.errors = {}
            this.loading = true

            axios.post('/api/mail/test', this.record, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage('Testmail succesvol verstuurd!')
                this.showPromptModal = false
                this.lastPreviewSentTime = new Date().toISOString()
                this.startCountdown()
                this.loading = false
            }).catch((error) => {
                console.error('[❌] Error while sending testmail:', error)

                if (error.response?.data?.errors?.subject || error.response?.data?.errors?.content) {
                    this.showPromptModal = false
                    this.errors = {...error.response.data.errors}
                    this.showError('Onvoldoende of onjuiste gegevens.')
                } else if (error.response?.data?.errors?.email) {
                    this.errors = {...error.response.data.errors}
                    this.showError('Een email adres is verplicht.')
                }

                this.loading = false
            })
        },

        contentChanged(content){
            this.$set(this.record, 'content', content)
        },

        onCustomerSelect(customer) {
            this.selectedCustomer = customer
            this.record.customer = customer.id
            this.receivers = 1
        },

        setDefaultSchedule() {
            const now = new Date()

            // Set date to today
            this.record.send_date = now

            // Set time to next quarter hour
            const minutes = now.getMinutes()
            const nextQuarter = Math.ceil(minutes / 15) * 15
            let hours = now.getHours()
            let adjustedMinutes = nextQuarter

            // Handle hour rollover
            if (nextQuarter >= 60) {
                hours += 1
                adjustedMinutes = 0
            }

            // If outside business hours (9-17), set to next business day at 9:00
            if (hours < 9 || hours >= 17 || (hours === 17 && adjustedMinutes > 0)) {
                const tomorrow = new Date(now)
                tomorrow.setDate(now.getDate() + (hours >= 17 ? 1 : 0))
                this.record.send_date = tomorrow
                hours = 9
                adjustedMinutes = 0
            }

            // Set time as Date object
            const timeDate = new Date()
            timeDate.setHours(hours, adjustedMinutes, 0)
            this.record.send_time = timeDate
        },

        findCustomer() {
            this.showFindCustomerModal = true
            this.$refs.findCustomer.addCustomer()
        },

        fetchPriceChangeCommunication(priceChangeId) {
            // Load the price change record and the communication template in parallel,
            // then resolve variables and pre-fill subject + content.
            const pcRequest = axios.get(`/api/contractpricechange/${priceChangeId}`, {
                headers: { 'Authorization': 'bearer ' + this.$store.state.authToken }
            })

            const commRequest = axios.get(`/api/communication/pricechange?organisation=${this.user.organisation}`, {
                headers: { 'Authorization': 'bearer ' + this.$store.state.authToken }
            })

            Promise.all([pcRequest, commRequest]).then(([pcResponse, commResponse]) => {
                const pc   = pcResponse.data
                const comm = commResponse.data

                const minPlus = pc.min_plus === 'min' ? 'verlaagd' : 'verhoogd'
                const prijs   = parseFloat(pc.price).toFixed(2)
                const bedrag  = pc.type === 'perc' ? `${prijs}%` : `€${prijs}`
                const datum   = pc.date_from
                    ? moment(pc.date_from).format('DD-MM-YYYY')
                    : ''

                const resolve = (str) => str
                    .replace(/\{min_plus\}/g, minPlus)
                    .replace(/\{bedrag\}/g,   bedrag)
                    .replace(/\{datum\}/g,    datum)

                this.$set(this.record, 'subject', resolve(comm.title))
                this.$set(this.record, 'content', resolve(comm.content))
            }).catch((error) => {
                console.error('[❌] Error fetching pricechange communication:', error)
            })
        },

        fetchAllPriceChanges() {
            return axios.get(`/api/contractpricechange?organisation=${this.user.organisation}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(response => {
                this.priceChanges = response.data.data
            }).catch(error => {
                this.$buefy.toast.open({message: 'Error: Kon prijswijzigingen niet laden!', type: 'is-danger'})
            })
        }
    },

    watch: {
        'record.organisation' (newVal) {
            this.fetchIntroFooterText(newVal)
        },

        'record.type' (newVal) {
            if (newVal !== 'specific_customer') {
                this.selectedCustomer = null
                delete this.record.customer
            }
            if (newVal === 'specific_customer' && this.mode !== 'view') {
                this.findCustomer()
            }

            this.fetchReceiversCount(newVal)
        }
    },

    beforeDestroy() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
        }
    }
}
</script>
